import { Dictionary } from 'types/dictionary';

interface FcProduct {
    blocked: boolean;
    participates: boolean;
    trialPeriod: {
        active: boolean;
        allowedRetailers: string[];
    };
}

export type FcProducts = Dictionary<FcProduct, 'productName', FcProductName>;

export enum FcProductName {
    EndlessAisle = 'endlessAisle',
    OrderPlatform = 'orderPlatform',
    ContentPlatform = 'contentPlatform',
    PreorderPlatform = 'preorderPlatform',
    AutoRestock = 'autoRestock',
    Suggestions = 'suggestions',
    ProductData = 'productData',
    MarketingMaterial = 'marketingMaterial',
    Landing = 'landing'
}

export enum SmartRepAccessRight {
    FullAccess = 'FullAccess',
    ViewOnly = 'ViewOnly'
}
